import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {Card} from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'

import FlightStatusTable from 'features/HomePage/FlightStatus/components/FlightStatusTable'
import Form from './components/Form'
import {ENDPOINT} from 'config/path'
import Breadcrumb from 'shared/BreadCrumb'
import {toggleLoginPopup} from 'features/Login/login.slice'
import {useLocation, useNavigate} from 'react-router-dom'
import {LazyLoadComponent} from 'react-lazy-load-image-component'
import {resetState} from './flightstatus.slice'

const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: '2-digit'
}

const flightStatusBreadcrumbs = [
    {
        path: `${ENDPOINT.basePath}${ENDPOINT.dashboard}`,
        label: (
            <React.Fragment>
                <HomeIcon /> Home
            </React.Fragment>
        )
    },
    {
        label: 'Flight status'
    }
]

const ViewFlightStaus = () => {
    const location = useLocation()
    const defaultValues = useSelector((state: any) => state.flightStatus.initialValues)
    const carrier = useSelector((state: any) => state.flightStatus.carrier)

    const date = new Date(defaultValues.flightDate)

    const isLoggedIn = useSelector((state: any) => state.login.isLoggedIn)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        if (defaultValues?.carrier === '-Select-' || defaultValues?.flightNo?.length < 1) {
            navigate(ENDPOINT.homepage)
        }
        if (location.pathname === ENDPOINT.viewFlightStatus) {
            if (isLoggedIn) {
                dispatch(toggleLoginPopup(false))
            } else {
                dispatch(toggleLoginPopup(true))
            }
        }
        return () => {
            dispatch(resetState())
            dispatch(toggleLoginPopup(false))
        }
    }, [])

    return (
        <div className='main_container'>
            <Breadcrumb list={flightStatusBreadcrumbs} />
            <div className='flight-status__container'>
                <div className='backdrop' />
                <Card className='frontdrop-container'>
                    <div className='frontdrop-content'>
                        <div className='flight-view'>
                            <strong className='carrier'>{carrier}</strong> &nbsp;
                            <strong>{defaultValues.flightNo}</strong>
                        </div>
                        <span>{date.toLocaleDateString('en-US', options)}</span>
                    </div>
                </Card>
                <div className='status-container'>
                    <LazyLoadComponent>
                        <Form />
                    </LazyLoadComponent>
                    <FlightStatusTable />
                </div>
            </div>
        </div>
    )
}

export default ViewFlightStaus
